import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const useGetPageParam = () => {
    const { search } = useLocation();
    const [pageParam, setPageParam] = useState({
        page: 0,
        page_size: 12,
    });

    useEffect(() => {
        const queryParams = new URLSearchParams(search);
        const updatedParams = { page: 0, page_size: 12 };

        for (const [key, value] of queryParams.entries()) {
            if (key === "page") {
                const pageValue = parseInt(value, 10);
                updatedParams.page = isNaN(pageValue) ? 0 : Math.max(0, pageValue - 1);
            } else {
                updatedParams[key] = value;
            }
        }

        setPageParam(updatedParams);
    }, [search]);

    const sortObject = (obj) =>
        Object.keys(obj)
            .sort()
            .reduce((acc, key) => {
                acc[key] = obj[key];
                return acc;
            }, {});

    const getProcessedRequestObject = (paramsReq) => {
        const merged = { ...paramsReq, ...pageParam };
        merged.page = merged.page === 0 && !search.includes("page=") ? 1 : merged.page + 1;
        return sortObject(merged);
    };

    return [pageParam, setPageParam, getProcessedRequestObject];
};
